
import React from "react";
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import { AppSidebar } from "./AppSidebar";
import { AppHeader } from "./AppHeader";
import { useApp } from "@/context/AppContext";

interface AppLayoutProps {
  children: React.ReactNode;
  'data-testid'?: string;
}

export function AppLayout({ children, 'data-testid': dataTestId }: AppLayoutProps) {
  // Use sidebar state from context to sync with shadcn sidebar
  const { sidebarCollapsed, setSidebarCollapsed } = useApp();

  return (
    <SidebarProvider
      defaultOpen={!sidebarCollapsed}
      onOpenChange={(open) => setSidebarCollapsed(!open)}
    >
      <AppSidebar />
      <SidebarInset 
        className="flex flex-col min-h-screen bg-background transition-all duration-300 ease-in-out"
        data-testid={dataTestId}
      >
        <AppHeader />
        <main className="flex-1 flex flex-col p-4 sm:p-6 lg:p-8 overflow-x-hidden w-full max-w-[100vw]">
          <div className="flex-1 w-full max-w-7xl mx-auto space-y-6">
            {children}
          </div>
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
}
